<template>
  <v-row
    no-gutters
    dense
  >
    <v-col
      cols="12"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card
          outlined
        >
          <v-card-text>
            <v-expansion-panels
              v-model="panel"
              multiple
            >
              <v-expansion-panel>
                <v-expansion-panel-header>WHOIS</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <pre>{{ whois }}</pre>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>DNS</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="ns-records"><h4>A records:</h4>
                    <ul>
                      <li :key="index" v-for="(item, index) in dns.a">{{ item }}</li>
                    </ul>
                  </div>
                  <div class="ns-records"><h4>MX records:</h4>
                    <ul>
                      <li :key="index" v-for="(item, index) in dns.mx">{{ item }}</li>
                    </ul>
                  </div>
                  <div class="ns-records"><h4>TXT records:</h4>
                    <ul>
                      <li :key="index" v-for="(item, index) in dns.txt">{{ item }}</li>
                    </ul>
                  </div>
                  <div class="ns-records"><h4>NS records:</h4>
                    <ul>
                      <li :key="index" v-for="(item, index) in dns.ns">{{ item }}</li>
                    </ul>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AgentDomainDoctor',
  components: {
  },
  created() {
    this.uid = this.$store.state.user.id;
    this.tid = this.$route.params.tid;
    this.domain = this.$route.params.domain;
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const dd = String(today.getDate()).padStart(2, '0');
    this.uuid = `${this.uid}_${this.tid}_${this.domain}_${yyyy}-${mm}-${dd}`;
    this.$api.post('agent/whois', {
      domain: this.domain,
    }).then((response) => {
      const respData = response.data;
      if (respData.is_error === false) {
        this.whois = respData.whois;
      }
    }).catch((error) => {
      if (error.response) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: error.response.data.message || error.response.data,
        });
      }
    });
    this.$api.post('agent/dns-lookup', {
      domain: this.domain,
    }).then((response) => {
      const respData = response.data;
      if (respData.is_error === false) {
        this.dns = respData.message;
      }
    }).catch((error) => {
      if (error.response) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: error.response.data.message || error.response.data,
        });
      }
    });
  },
  /* eslint-disable */
  mounted() {
  },
  /* eslint-enable */
  data() {
    return {
      doctorStatus: '<span style="color:orange">server lookup</span>',
      uid: '',
      tid: '',
      uuid: '',
      panel: [0, 1],
      processing: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
      valid: false,
      ticket: '',
      domain: '',
      purpose: '',
      form: {
      },
      whois: '',
      dns: [],
      menus: [],
      inputFields: [],
      hostname: '',
      commandId: '',
      commandDialog: false,
      commandParams: {},
      timer: null,
      consoleLog: '',
      commandHistory: null,
      historyId: 0,
    };
  },
  beforeDestroy() {
  },
  methods: {
  },
};
</script>

<style scoped>
.server-console {
  height: 512px;
  max-width: 5120px;
  overflow: auto;
  border: 1px solid lightgrey;
  padding: 15px;
}

.server-console {
  background-color: #000;
}

.server-console pre {
  background-color: black;
  color: rgb(0, 255, 0);
  border: 0;
  padding: 0;
  margin: 0;
}

.server-console a {
  text-decoration: underline;
}

.text-command {
  color: #fff;
}

.server-console .text-success {
  color: #00bb00;
}

.btn-copy {
  color: #fff;
  background-color: #20895e;
  border-color: #196c4b;
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
